import { LyricsPart } from "../../chordsheet/LyricsExtractor";

export function getLyricsPartLabel(
  part: Pick<LyricsPart, "label" | "type" | "indexByTypeOneBased">,
): string {
  if (part.label) {
    return part.label;
  }
  const type = part.type;
  const isOmitted = !type || type === "none";
  return isOmitted
    ? `${part.indexByTypeOneBased}`
    : `${type.charAt(0).toUpperCase() + type.slice(1)} ${part.indexByTypeOneBased}`;
}
